import { AHText, AHTextFonts, Box, ListItem } from "arkh";
import React, { useMemo } from "react";
import { KPIFillMode } from "./KPIEditParamList";

import { useDaysDescription } from "../components/useDaysDescription";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";

function useFillModeDescription(selectedDays: number[], fillMode: KPIFillMode) {
  const intl_tokens = useIntlTokens();
  return useMemo(() => {
    if (selectedDays.length !== 1) {
      if (fillMode === "current") {
        return intl_tokens.EnterTodaysValue;
      } else {
        return intl_tokens.EnterYesterdaysValue;
      }
    } else {
      if (fillMode === "current") {
        return intl_tokens.EnterThisWeeksValue;
      } else {
        return intl_tokens.EnterLastWeeksValue;
      }
    }
  }, [
    fillMode,
    intl_tokens.EnterLastWeeksValue,
    intl_tokens.EnterThisWeeksValue,
    intl_tokens.EnterTodaysValue,
    intl_tokens.EnterYesterdaysValue,
    selectedDays.length,
  ]);
}

export const KPIFrequenceListItem = (props: {
  fillMode: KPIFillMode;
  byweekday: number[];
}) => {
  const daysDescription = useDaysDescription(props.byweekday);
  const fillModeDescription = useFillModeDescription(
    props.byweekday,
    props.fillMode
  );
  return (
    <ListItem isFirst isLast border="border-primary">
      <Box style={{ flexDirection: "row", alignItems: "center", flex: 1 }}>
        <ListItem.Title>{daysDescription}</ListItem.Title>
        <Box spaceHorizontal="small">
          <Box style={{ width: 1, height: "100%" }} color="border-primary" />
        </Box>
        <AHText type="body" font={AHTextFonts.BOLD} style={{ flex: 1 }}>
          {fillModeDescription}
        </AHText>
      </Box>
    </ListItem>
  );
};
